'use client'

import { motion } from 'motion/react'

import {
  SiInstagram, SiInstagramHex, SiSoundcloud, SiSoundcloudHex,
  SiSpotify, SiSpotifyHex, SiTiktok, SiVimeo, SiVimeoHex,
  SiYoutube, SiYoutubeHex,
} from '@icons-pack/react-simple-icons'

import { Orbiting } from '@/components/ui/orbiting'

import { LogoMark } from '@/components/elements/Logo'

/**
 * What orbits the Fuse mark.
 *
 * TikTok publishes its mark as black, which disappears on a dark card, so it
 * follows the theme's text colour instead, the same rule
 * `components/dashboard/socials.ts` applies for exactly that reason.
 */
const ORBIT = [
  { Icon: SiSpotify, label: 'Spotify', hex: SiSpotifyHex },
  { Icon: SiYoutube, label: 'YouTube', hex: SiYoutubeHex },
  { Icon: SiInstagram, label: 'Instagram', hex: SiInstagramHex },
  { Icon: SiTiktok, label: 'TikTok', hex: undefined },
  { Icon: SiSoundcloud, label: 'SoundCloud', hex: SiSoundcloudHex },
  { Icon: SiVimeo, label: 'Vimeo', hex: SiVimeoHex },
]

const Circles = () => {
  return (
    <div className='relative flex size-75 shrink-0 items-center justify-center'>
      <Orbiting radius={125} duration={30} strokeWidth={1}>
        {/* The platforms a Fuse block actually embeds, not the stack the site
            is built with. `components/profile/embed.ts` is the list that
            decides: Spotify, YouTube, SoundCloud and Vimeo become real players,
            and Instagram and TikTok are the social blocks people add most. */}
        {ORBIT.map(({ Icon, label, hex }) => (
          <div
            key={label}
            className='bg-background grid size-13 place-content-center rounded-full border shadow-sm'
          >
            <Icon className='size-6.5' color={hex} title={label} />
          </div>
        ))}
      </Orbiting>
      <motion.svg
        width='1em'
        height='1em'
        viewBox='0 0 246 246'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='absolute size-61.5'
        initial='hidden'
        animate='visible'
      >
        <motion.circle
          strokeOpacity={0.8}
          cx='123'
          cy='123'
          r='80'
          stroke='var(--border)'
          strokeWidth='1.125'
          variants={{
            visible: {
              scale: [0.96, 1.12, 0.96],
              transition: {
                scale: { delay: 0.36, duration: 2.75, repeat: Infinity, ease: 'easeOut' }
              }
            }
          }}
        />
        <motion.circle
          strokeOpacity={1}
          cx='123'
          cy='123'
          r='50'
          stroke='var(--border)'
          strokeWidth='1.125'
          variants={{
            visible: {
              scale: [0.96, 1.12, 0.96],
              transition: {
                scale: { delay: 0.48, duration: 2.75, repeat: Infinity, ease: 'easeOut' }
              }
            }
          }}
        />
      </motion.svg>
      <LogoMark size={64} alt='' />
      <div className='from-card pointer-events-none absolute inset-x-0 -bottom-1.5 h-10 bg-gradient-to-t from-10% to-transparent' />
    </div>
  )
}

export default Circles
